export default {
  UPDATE_ALL_CATEGORY: 'CATEGORY/UPDATE_ALL_CATEGORY'
};
